<template>
  <!-- <div
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    v-loading="hui"
    style="background-color: #0e0f1e; color: #fff;height:100vh;width:100%"
    v-if="hui"
  ></div> -->
  <div
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    style="background-color: #0e0f1e; color: #fff; min-width: 1200px"
  >
    <div v-if="hui" id="lives">
      <el-row class="pingui">
        <el-col :offset="viewFlag ? 0 : 3" :span="18" class="pingui">
          <el-col
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
            :span="16"
          >
            <span class="live_title">{{ courseName }}</span>
          </el-col>
          <el-col class="title_right" :span="8">
            <span>
              <img
                style="vertical-align: sub"
                width="18px"
                src="../../assets/img/guankan.png"
                alt=""
              />
              {{ numberData(viewNum) }}
            </span>
            <span style="margin-left: 30px">
              <img
                style="vertical-align: bottom"
                width="18px"
                src="../../assets/img/dian-num.png"
                alt=""
              />
              {{ numberData(lessonZannum) }}
            </span>
          </el-col>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 左侧直播模块 -->
        <el-col
          :style="{ height: height }"
          style="position: relative"
          :span="viewFlag ? 18 : 24"
        >
          <img
            src="../../assets/img/wdl.png"
            class="img video_live"
            width="100%"
            v-if="!token && isHaveRight == 0"
            @click="dialogVisible = true"
          />
          <img
            src="../../assets/img/wqx.png"
            class="img video_live"
            style="max-width: 1240px"
            v-if="token && isHaveRight == 0"
          />
          <video-player
            v-if="isHaveRight == 1"
            class="video-player vjs-custom-skin video_live"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            @ready="playerReadied"
            @timeupdate="onPlayerTimeupdate($event)"
            @ended="onPlayerEnded($event)"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
          ></video-player>
        </el-col>
        <!-- 右侧交互模块 -->
        <el-col :span="6" v-show="viewFlag">
          <div
            :style="{ height: height }"
            class="right_centent"
            v-show="viewFlag"
          >
            <el-tabs v-model="activeRight" @tab-click="handleClick">
              <el-tab-pane
                v-if="commentsIsOpen == 1"
                label="讨论"
                name="interactive"
              >
                <div style="height: 84%; width: 100%">
                  <div
                    id="infinite-list"
                    class="infinite-list"
                    v-infinite-scroll="load"
                    infinite-scroll-distance="80px"
                  >
                    <div class="com">
                      <div class="user_com" v-show="datalistu.length !== 0">
                        <div
                          class="user_com_list"
                          v-for="(item, idx) in datalistu"
                          :key="idx"
                        >
                          <div>
                            <el-image
                              :src="item.userHeadImg"
                              style="
                                width: 28px;
                                height: 28px;
                                border-radius: 4px;
                              "
                            >
                              <div slot="error" class="image-slot">
                                <img
                                  width="28"
                                  src="../../assets/img/header_img.png"
                                  alt=""
                                />
                              </div>
                            </el-image>
                          </div>
                          <div class="com_list_cen">
                            <div style="width: 100%">
                              <span style="color: #a0a1a8">{{
                                item.userName ? item.userName : "未知错误"
                              }}</span>
                              <span style="float: right">
                                <span
                                  class="del_centent"
                                  @click="shanchu(item.feelingId)"
                                  >删除</span
                                >
                                <span class="select_centent">未精选</span>
                              </span>
                            </div>
                            <div style="margin-top: 5px; letter-spacing: 2px">
                              {{ item.feelingContent }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-show="datalistu.length !== 0"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 15px;
                          justify-content: space-around;
                        "
                      >
                        <span class="xian"></span>
                        <span class="xian_text"
                          >以上留言被精选后，将对所有人可见</span
                        >
                        <span class="xian"></span>
                      </div>
                      <div class="com_centent">
                        <div
                          class="user_com_list"
                          style="display: flex"
                          v-for="(item, idx) in datalist"
                          :key="idx"
                        >
                          <div>
                            <el-image
                              :src="item.userHeadImg"
                              style="
                                width: 28px;
                                height: 28px;
                                border-radius: 4px;
                              "
                            >
                              <div slot="error" class="image-slot">
                                <img
                                  width="28"
                                  src="../../assets/img/header_img.png"
                                  alt=""
                                />
                              </div>
                            </el-image>
                          </div>
                          <div class="com_list_cen">
                            <div>
                              <div class="com_list_u">
                                <span style="color: #a0a1a8">{{
                                  item.userName ? item.userName : "未知错误"
                                }}</span>
                                <span class="com_dianzhan">
                                  <img
                                    width="16"
                                    v-if="
                                      item.likeList.findIndex(
                                        (items) => items.userId == userId
                                      ) !== -1 ||
                                      item.likeList.findIndex(
                                        (items) => items.sourceId == sourceId
                                      ) !== -1
                                    "
                                    @click="feelingCancelZan(item.feelingId)"
                                    src="../../assets/img/ydianzhan.png"
                                    alt=""
                                  />
                                  <img
                                    v-else
                                    @click="comGive(item.feelingId)"
                                    width="16"
                                    src="../../assets/img/wdianzhan.png"
                                    alt=""
                                  />
                                  {{ item.praseCount }}
                                </span>
                              </div>
                            </div>
                            <div style="margin-top: 5px; letter-spacing: 2px">
                              {{ item.feelingContent }}
                              <span v-if="item.isTop == 1" class="cen_istop"
                                >置顶</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="input_btn">
                    <div class="input_fa">
                      <!-- :disabled="!token && isHaveRight !== 0" -->
                      <el-input
                        v-model="textarea"
                        :placeholder="
                          token
                            ? '一起参与互动发言'
                            : visitorIsOpen == 1
                            ? '一起参与互动发言'
                            : '登录后一起参与互动发言'
                        "
                      ></el-input>
                      <el-button
                        v-if="token || visitorIsOpen == 1"
                        @click="lessonfeeling"
                        :disabled="isHaveRight != 1"
                        class="btn_sub"
                        size="mini"
                        type="danger"
                        :loading="feelingFlag"
                        round
                        >交流</el-button
                      >
                      <el-button
                        v-else
                        @click="dialogVisible = true"
                        class="btn_sub"
                        size="mini"
                        type="danger"
                        round
                        >登录</el-button
                      >
                    </div>
                    <!-- v-if="!!token" -->
                    <div class="dianzan" @click="lessonZan">
                      <img
                        width="38"
                        src="../../assets/img/like.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                v-if="spectatorIsOpen == 1"
                label="观众"
                name="audience"
              >
                <div style="height: 84%; width: 100%">
                  <div
                    class="infinite-list"
                    v-infinite-scroll="loadPeo"
                    infinite-scroll-distance="80px"
                    style="height: 100%; width: 100%; overflow: auto"
                  >
                    <div class="peo_num">
                      <img
                        style="vertical-align: text-bottom"
                        src="../../assets/img/peonum.png"
                        width="18"
                        alt=""
                        srcset=""
                      />
                      <span>直播间人数：{{ numberData(peototalCount) }}</span>
                    </div>
                    <div
                      class="peo_list"
                      v-for="item in peopleList"
                      :key="item.id"
                    >
                      <el-image
                        :src="item.avatarUrl"
                        style="width: 28px; height: 28px; border-radius: 4px"
                      >
                        <div slot="error" class="image-slot">
                          <img
                            width="28"
                            src="../../assets/img/header_img.png"
                            alt=""
                          />
                        </div>
                      </el-image>
                      <span style="margin-left: 10px; color: #58ccea">
                        {{ item.viewersName }}
                      </span>
                      <span style="margin-left: 10px; color: #a0a1a8"
                        >({{ item.schoolName }})</span
                      >
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                label="回放目录"
                name="playback"
                v-if="huifang && liveStatus == 4"
              >
                <div class="playback_list">
                  <div
                    v-for="item in videoVoList"
                    :key="item.videoId"
                    @click="xuans(item.videoId, item)"
                    :class="{ playback_c: item.videoId == lessonsid }"
                    style="margin-bottom: 15px"
                    class="playback"
                  >
                    <span style="display: inline-block">
                      {{ timeDeal(item.beginTime) }} -
                      {{ timeDeal(item.endTime) }}
                    </span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="hui" class="select_list">
      <el-col :span="24">
        <el-tabs v-model="activeName">
          <el-tab-pane label="课程介绍" name="first">
            <div
              v-if="courseInfos"
              class="textjieshao"
              v-html="courseInfos"
            ></div>
            <div v-else style="text-align: center">暂无课程介绍...</div>
          </el-tab-pane>
          <el-tab-pane
            :label="list.resTypeName"
            :name="list.restypeId.toString()"
            v-for="list in netClassResTypeVos"
            :key="list.restypeId"
          >
            <el-col
              :span="24"
              v-for="dais in list.netClassResPubVos"
              :key="dais.resId"
              class="pinjui"
            >
              <el-col :span="1">
                <img
                  src="../../assets/img/l-word.png"
                  width="20px"
                  v-if="dais.fileFormat == 'docx'"
                  style="vertical-align: middle"
                />
                <img
                  src="../../assets/img/l-ppt.png"
                  width="20px"
                  v-if="dais.fileFormat == 'ppt' || dais.fileFormat == 'pptx'"
                  style="vertical-align: middle"
                />
                <img
                  src="../../assets/img/l-video.png"
                  width="20px"
                  v-if="dais.fileFormat == 'mp4'"
                  style="vertical-align: middle"
                />
                <img
                  src="../../assets/img/l-pdf.png"
                  width="20px"
                  v-if="dais.fileFormat == 'pdf'"
                  style="vertical-align: middle"
                />
                <img
                  src="../../assets/img/l-img.png"
                  width="20px"
                  v-if="dais.fileFormat == 'png'"
                  style="vertical-align: middle"
                />
                <img
                  src="../../assets/img/l-word.png"
                  width="20px"
                  v-if="!dais.fileFormat"
                  style="vertical-align: middle"
                />
              </el-col>
              <el-col :span="17" style="line-height: 30px">{{
                dais.resTitle
              }}</el-col>
              <el-col :span="6" style="text-align: right">
                <el-button type="text" @click="yula(dais.resId)"
                  >预览</el-button
                >
              </el-col>
            </el-col>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </div>
    <div class="quename" v-if="!hui">
      <div class="que_img">
        <img
          width="300"
          src="../../assets/img/live_none.png"
          alt=""
          srcset=""
        />
        <span style="margin-top: 10px">课程已删除或不存在</span>
      </div>
    </div>
    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="region">
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择身份"
            style="width: 100%"
          >
            <el-option label="学校管理员" value="school"></el-option>
            <el-option label="老师" value="teacher"></el-option>
            <!-- <el-option label="学生" value="student"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="" prop="input">
          <el-input
            v-model="ruleForm.input"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 100%"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { videoPlayer } from "vue-video-player";
import "videojs-contrib-hls";
// require('videojs-contrib-hls/dist/videojs-contrib-hls.js')
import "videojs-flash";
import {
  courselesson,
  lessonsetview,
  lessonfeeling,
  lessonfeelinglist,
  lessonfeelingdel,
  note,
  notecheckIsExist,
  lessonSetView,
  usercenterinfo,
  userlogin,
  obtainIp,
  PCIntoInsert,
  PcQuitUpate,
  viewerWatchRecord,
  lessonZan,
  feelingZan,
  feelingCancelZan,
  getLiveStatus,
} from "@/api/home";
export default {
  data() {
    return {
      playerOptions: {
        live: true,
        autoplay: true,
        notSupportedMessage: "",
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          autoDisable: false,
          progressControl: true,
          fullscreenToggle: true, // 全屏按钮
        },
        // techOrder: ['flash'],
        // flash: {
        // 	hls: { withCredentials: false },
        // },
        // 封面
        poster: require("../../assets/img/默认页.png"),
        sources: [],
      },
      ruleForm: {
        name: "",
        region: "teacher",
        input: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写账号",
            trigger: "blur",
          },
        ],
        input: [
          {
            required: true,
            message: "请填写密码",
            trigger: "blur",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change",
          },
        ],
      },
      moimgs: "../../assets/img/默认页.png",
      dslist: {},
      courseName: "",
      lessonId: "",
      lessonVos: [],
      hui: true,
      lessonsid: "",
      netClassResTypeVos: [],
      activeName: "first",
      loading: false,
      textarea: "",
      parentId: "",
      replyRoleType: "",
      replyUserId: "",
      replyUserName: "",
      roleType: localStorage.getItem("roleType"),
      userId: localStorage.getItem("userId"),
      userName: localStorage.getItem("userName"),
      placeholder: "记录你的听课感受",
      courseId: "",
      curPage: 1,
      pageSize: 10,
      datalist: [],
      datalistu: [],
      totalCount: 0,
      gklog: 0,
      huix: false,
      noteTime: 0,
      watchOver: 0,
      times: "",
      videoVoList: [],
      courseInfos: "",
      huifang: false,
      token: localStorage.getItem("token"),
      isHaveRight: "",
      dialogVisible: false,
      _gap_time: "",
      beforeUnload_time: "",
      activeRight: "interactive",
      peopleList: [],
      peoPageNum: 1,
      peoPageSize: 10,
      peototalCount: 0,
      commentsIsOpen: 0,
      peoTime: "",
      height: "700px",
      spectatorIsOpen: 0,
      visitorIsOpen: 0,
      liveInter: "",
      liveStatus: -1,
      viewFlag: true,
      sourceId: 0,
      lessonZannum: 0,
      viewNum: 0,
      message: "",
      dianInter: "",
      lessonZanDate: 0,
      feelingFlag: false,
    };
  },
  watch: {},
  methods: {
    // tab点击事件
    handleClick(e) {
      // console.log(e);
      // this.activeRight = e.name
      clearInterval(this.peoTime);
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      this.sourceId = ip;
      if (this.activeRight == "interactive") {
        this.curPage = 1;
        this.lessonfeelinglist(1);
        this.lessonfeelinglist();
        return false;
      }
      if (this.activeRight == "audience") {
        clearInterval(this.peoTime);
        this.peoTimes();
        this.peoPageNum = 1;
        this.viewerWatchRecord();
        return false;
      }
    },
    // 图片加载失败
    errorHandler() {
      return true;
    },
    focuser() {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$message.error("未登录，请登录后发表评论！！！");
      }
    },
    async lessonSetView() {
      const res = await lessonSetView({
        lessonId: this.lessonId,
      });
    },
    // 获取课程信息
    courselesson(flag = 0) {
      let that = this;
      //   that.loading = true;
      let params = {
        id: that.lessonId,
      };
      courselesson(params)
        .then((res) => {
          if (res.data.code != 0) {
            that.hui = false;
            return false;
          }
          //   that.loading = false;
          that.dslist = res.data.data;
          that.courseName = res.data.data.netClassCourseVo.courseName;
          that.courseInfos = that.dslist.netClassCourseVo.courseInfo;
          that.lessonVos = res.data.data.netClassCourseVo.lessonVos;
          that.isHaveRight = res.data.data.isHaveRight;
          that.commentsIsOpen = res.data.data.commentsIsOpen;
          that.spectatorIsOpen = res.data.data.spectatorIsOpen;
          that.visitorIsOpen = res.data.data.visitorIsOpen;
          that.lessonZannum = res.data.data.lessonZannum || 0;
          that.viewNum = res.data.data.lessonViewnum || 0;

          // playback
          if (that.commentsIsOpen == 0 && that.spectatorIsOpen == 0) {
            that.activeRight = "playback";
          }
          if (that.commentsIsOpen == 1 && that.spectatorIsOpen == 1) {
            that.activeRight = "interactive";
          }
          if (that.commentsIsOpen == 0 && that.spectatorIsOpen == 1) {
            that.viewerWatchRecord();
            that.activeRight = "audience";
          }
          if (that.commentsIsOpen == 1 && that.spectatorIsOpen == 0) {
            that.activeRight = "interactive";
          }
          // 清除3分钟定时刷新
          clearTimeout(that.liveInter);
          that.huifangs();
          if (res.data.data.netClassResTypeVos !== null) {
            that.netClassResTypeVos = res.data.data.netClassResTypeVos;
            // that.activeName = res.data.data.netClassResTypeVos[0].restypeId.toString();
          } else {
            that.activeName = "first";
          }
          that.courseId = res.data.data.courseId;
          that.hui = true;
          if (flag == 1) {
            return false;
          }
          if (flag != 2) {
            that.PCIntoInsert();
          }
          if (that.activeRight == "interactive" && flag != 2) {
            let date = localStorage.getItem("dates");
            let ip = returnCitySN.cip + "@" + date;
            this.sourceId = ip;
            this.lessonfeelinglist(1);
            this.lessonfeelinglist();
          }
          if (
            res.data.data.fileModel !== null &&
            res.data.data.fileModel.serverId == "2"
          ) {
            clearInterval(that.times);
            // that.PCIntoInsert();
            let list = [
              {
                type: "video/mp4",
                src: res.data.data.fileModel.fileUrl,
              },
            ];
            // that.timeInter();
            that.playerOptions.sources = list;
            // that.notecheckIsExist();
          }
          if (
            res.data.data.fileModel == null ||
            res.data.data.fileModel.serverId == "1"
          ) {
            // that.liveStatus = res.data.data.liveStatus;
            if (res.data.data.liveStatus == 4) {
              that.playerOptions.controlBar.progressControl = true;
              clearInterval(that.times);
              // that.PCIntoInsert();
              that.videoVoList = res.data.data.videoVoList;

              // 处理回放目录显示时机问题

              // 处理时间秒问题
              that.videoVoList.forEach((item, index) => {
                that.videoVoList[index].beginTime = item.beginTime.slice(
                  0,
                  item.beginTime.lastIndexOf(":")
                );
                that.videoVoList[index].endTime = item.endTime.slice(
                  0,
                  item.endTime.lastIndexOf(":")
                );
              });

              that.lessonsid = that.videoVoList[0].videoId;
              let url =
                that.videoVoList[0].serverHttp + that.videoVoList[0].fileUrl;
              let list = [
                {
                  type: "video/mp4",
                  src: url,
                },
              ];
              // that.timeInter();
              if (that.playerOptions.sources.length == 0) {
                that.playerOptions.sources = list;
              }
              // that.notecheckIsExist();
            } else if (res.data.data.liveStatus == 3) {
              clearInterval(that.times);
              that.playerOptions.poster = require("../../assets/img/回放.png");
              let list = [
                {
                  type: "video/mp4",
                  src: "",
                },
              ];
              that.timeInter();
              that.getLiveStatus();
              that.playerOptions.sources = list;
            } else if (res.data.data.liveStatus == 2) {
              that.playerOptions.poster = require("../../assets/img/直播未开始.png");
              // that.playerOptions.notSupportedMessage =
              //   "直播暂未开始，请稍后。。。";
              let list = [
                {
                  type: "video/mp4",
                  src: "",
                },
              ];
              that.timeInter();
              if (flag != 2) {
                that.getLiveStatus();
              }
              that.playerOptions.sources = list;
              if (flag != 2) {
                if (
                  that.spectatorIsOpen == 1 &&
                  that.activeRight == "audience"
                ) {
                  clearInterval(that.peoTime);
                  that.peoTimes();
                } else {
                  clearInterval(that.peoTime);
                }
              }
              //
            } else if (res.data.data.liveStatus == 1) {
              clearInterval(that.times);
              // that.PCIntoInsert();
              let list = [
                {
                  type: "application/x-mpegURL",
                  src: res.data.data.rtmpUrl,
                },
              ];
              that.timeInter();
              if (flag != 2) {
                that.getLiveStatus();
              }

              that.playerOptions.sources = list;
              if (flag != 2) {
                if (
                  that.spectatorIsOpen == 1 &&
                  that.activeRight == "audience"
                ) {
                  clearInterval(that.peoTime);
                  that.peoTimes();
                } else {
                  clearInterval(that.peoTime);
                }
              }
            }
          }
          if (
            that.commentsIsOpen == 0 &&
            that.spectatorIsOpen == 0 &&
            that.liveStatus != 4
          ) {
            that.viewFlag = false;
          } else {
            that.viewFlag = true;
          }
          that.lessonsetview();
          // that.notecheckIsExist();
          // 处理视频播放高度
          that.$refs.videoPlayer.player.play();
          setTimeout(() => {
            let videos = document.getElementsByClassName("video_live");
            that.height = videos[0].clientHeight + "px";
          }, 1000);
        })
        .catch(() => {
          //   that.loading = false;
        });
    },
    // 获取直播状态
    getLiveStatus(flag = 0) {
      let that = this;
      // let date = localStorage.getItem("dates");
      // let ip = returnCitySN.cip + "@" + date;
      // this.sourceId = ip;
      getLiveStatus({
        lessonId: this.lessonId,
      }).then((res) => {
        this.lessonZannum = res.data.data.zanNum || 0;
        this.viewNum = res.data.data.viewNum || 0;
        // 判断tab栏选中状态 2代表循环调用不作用
        if (
          flag != 2 ||
          that.commentsIsOpen != res.data.data.commentsIsOpen ||
          that.spectatorIsOpen != res.data.data.spectatorIsOpen
        ) {
          if (
            res.data.data.commentsIsOpen == 0 &&
            res.data.data.spectatorIsOpen == 0
          ) {
            clearInterval(that.peoTime);
            that.activeRight = "playback";
          }
          if (
            res.data.data.commentsIsOpen == 1 &&
            res.data.data.spectatorIsOpen == 1
          ) {
            setTimeout(() => {
              that.$notify({
                title: "提示",
                message: "请在讨论区发言参与直播互动吧！",
                duration: 0,
              });
            }, 300000);
            that.curPage = 1;
            that.lessonfeelinglist();
            that.activeRight = "interactive";
          }
          if (
            res.data.data.commentsIsOpen == 0 &&
            res.data.data.spectatorIsOpen == 1
          ) {
            that.activeRight = "audience";
            that.viewerWatchRecord();
            clearInterval(that.peoTime);
            that.peoTimes();
          }
          if (
            res.data.data.commentsIsOpen == 1 &&
            res.data.data.spectatorIsOpen == 0
          ) {
            setTimeout(() => {
              that.$notify({
                title: "提示",
                message: "请在讨论区发言参与直播互动吧！",
                duration: 0,
              });
            }, 300000);
            that.curPage = 1;
            that.lessonfeelinglist();
            clearInterval(that.peoTime);
            that.activeRight = "interactive";
          }
        }
        if (
          res.data.data.commentsIsOpen == 1 &&
          res.data.data.commentsIsOpen != that.commentsIsOpen &&
          flag == 0
        ) {
          setTimeout(() => {
            that.$notify({
              title: "提示",
              message: "请在讨论区发言参与直播互动吧！",
              duration: 0,
            });
          }, 300000);
        }
        that.commentsIsOpen = res.data.data.commentsIsOpen;
        that.spectatorIsOpen = res.data.data.spectatorIsOpen;
        that.visitorIsOpen = res.data.data.visitorIsOpen;

        if (res.data.data.liveStatus == 1 || res.data.data.liveStatus == 2) {
          if (that.spectatorIsOpen != res.data.data.spectatorIsOpen) {
            if (that.spectatorIsOpen == 1 && that.activeRight == "audience") {
              // clearInterval(that.peoTime);
              // that.peoTimes();
            } else {
              clearInterval(that.peoTime);
            }
          }
        }
        if (that.liveStatus == 2) {
          that.playerOptions.poster = require("../../assets/img/直播未开始.png");
        }
        if (that.liveStatus == 3) {
          that.playerOptions.poster = require("../../assets/img/回放.png");
        }
        //  判断直播状态是否改变
        if (
          that.liveStatus !== -1 &&
          that.liveStatus != res.data.data.liveStatus
        ) {
          that.courselesson(2);
          that.liveStatus = res.data.data.liveStatus;
          return false;
        }
        that.liveStatus = res.data.data.liveStatus;

        if (
          that.commentsIsOpen == 0 &&
          that.spectatorIsOpen == 0 &&
          that.liveStatus != 4
        ) {
          that.viewFlag = false;
        } else {
          that.viewFlag = true;
        }
      });
    },
    playerStateChanged(e) {
      // console.log(e);
    },
    huifangs() {
      if (
        this.dslist.fileModel == null ||
        this.dslist.fileModel.serverId == "1"
      ) {
        if (!!this.dslist.videoVoList) {
          this.huifang = true;
        }
      }
    },
    yula(s) {
      let url = "http://bk.welaiedu.cn/#/prepare_pdf?id=" + s;
      window.open(url, "_blank");
    },
    xuan(s) {
      this.lessonsid = s;
      this.lessonId = s;
      this.courselesson();
    },
    xuans(s, list) {
      if (this.dslist.liveStatus == "1") {
        this.$message.error("正在直播中,请稍后查看");
        return false;
      }
      let url = list.serverHttp + list.fileUrl;
      let lists = [
        {
          type: "video/mp4",
          src: url,
        },
      ];
      this.playerOptions.sources = lists;
      that.$refs.videoPlayer.player.play();
    },
    // 进入直播 增加浏览量
    lessonsetview() {
      let that = this;
      //   that.loading = true;
      let params = {
        lessonId: parseInt(that.lessonId),
      };
      lessonsetview(params)
        .then((res) => {
          //   that.loading = false;
        })
        .catch(() => {
          //   that.loading = false;
        });
    },
    // 评论提交
    lessonfeeling() {
      let that = this;
      that.feelingFlag = true;
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      let params = {
        feelingContent: that.textarea,
        lessonId: that.lessonId,
        // roleType: that.roleType,
        // userId: that.userId,
        // userName: that.userName,
        courseId: that.courseId,
        sourceId: ip,
      };

      lessonfeeling(params)
        .then((res) => {
          if (res.data.code == 0) {
            that.$message({
              message: "发表成功,精选后展示！",
              type: "success",
            });
            that.textarea = "";
            that.placeholder = "记录你的听课感受";
            that.lessonfeelinglist(1);
            that.feelingFlag = false;
            console.dir(document.getElementById("infinite-list"));
            document.getElementById("infinite-list").scrollTop = 0;
            console.log(document.getElementById("infinite-list").scrollTop);
            return false;
          }
          that.$message.error(res.data.msg);
          that.feelingFlag = false;
        })
        .catch(() => {});
    },
    // 主题讨论 触底刷新
    load() {
      if (this.curPage * 10 >= this.totalCount) {
        // this.$message.error("没有更多了");
        return false;
      }
      this.curPage += 1;
      this.lessonfeelinglist();
      // if (this.totalCount > this.pageSize) {

      // }
    },
    // 主题讨论 列表
    lessonfeelinglist(flag = 0) {
      let that = this;
      let userId = localStorage.getItem("userId");
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      let params = {
        curPage: that.curPage,
        pageSize: that.pageSize,
        lessonId: that.lessonId,
        replyStatus: 1,
      };
      if (flag) {
        params.userId = userId;
        params.replyStatus = 0;
        params.sourceId = ip;
      }
      lessonfeelinglist(params)
        .then((res) => {
          if (that.curPage == 1 && flag == 0) {
            that.datalist = [];
          } else {
            that.datalistu = [];
          }
          let data = res.data.data.dataList;
          if (flag == 1) {
            that.datalistu.push(...data);
          } else {
            that.datalist.push(...data);
          }
          that.totalCount = res.data.data.totalCount;
        })
        .catch(() => {});
    },
    // 评论 点赞
    comGive(id) {
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      // if (!this.token) {
      //   this.$message.error("请先登录再进行操作");
      //   return false;
      // }
      feelingZan({
        sourceId: ip,
        feelingId: id,
      }).then((res) => {
        if (res.data.code == 0) {
          this.datalist.forEach((item) => {
            if (item.feelingId == id) {
              let obj = {
                feelingId: id,
                sourceId: ip,
                userId: this.userId,
                userName: this.userName,
              };
              item.likeList.push(obj);
              item.praseCount++;
            }
          });
          // this.lessonfeelinglist();
        }
      });
    },
    // 评论 点赞取消
    feelingCancelZan(id) {
      let date = localStorage.getItem("dates");
      let ip = returnCitySN.cip + "@" + date;
      feelingCancelZan({
        sourceId: ip,
        feelingId: id,
      }).then((res) => {
        if (res.data.code == 0) {
          // this.lessonfeelinglist();
          this.datalist.forEach((item) => {
            if (id == item.feelingId) {
              let idxs = 0;
              item.likeList.forEach((like, idx) => {
                if (like.userId == this.userId || ip == like.sourceId) {
                  idxs = idx;
                }
              });
              item.likeList.splice(idxs, 1);
              item.praseCount--;
            }
          });
        }
      });
    },
    gai(s) {
      this.curPage = s;
      this.lessonfeelinglist();
    },
    // 删除评论
    shanchu(s) {
      let that = this;
      let params = {
        feelingId: s,
      };
      this.$confirm("确定删除此条评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lessonfeelingdel(params)
            .then((res) => {
              that.loading = false;
              that.lessonfeelinglist(1);
            })
            .catch(() => {
              that.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          that.loading = true;
          let params = {
            roleType: that.ruleForm.region,
            account: that.ruleForm.name,
            password: that.ruleForm.input,
          };
          userlogin(params)
            .then((res) => {
              that.loading = false;
              if (res.data.code == "0") {
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem("roleType", that.ruleForm.region);
                that.dialogVisible = false;
                // this.$router.go(0);
                location.reload();
                that.usercentergetinfo();
              } else {
                that.$message(res.data.msg);
              }
            })
            .catch(() => {
              that.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    usercentergetinfo() {
      let that = this;
      usercenterinfo()
        .then((res) => {
          localStorage.setItem("roleType", res.data.data.roleType);
          if (res.data.data.roleType == "student") {
            that.names = res.data.data.student.name;
            that.schoolname = res.data.data.student.schoolName;
            localStorage.setItem("userId", res.data.data.userId);
            localStorage.setItem("schoolId", res.data.data.student.schoolId);
            that.schoolgetinfo(res.data.data.student.schoolId);
            localStorage.setItem(
              "classesId",
              res.data.data.student.gradeClassesInfo.classesId
            );
            localStorage.setItem("rosterNo", res.data.data.student.rosterNo);
          } else if (res.data.data.roleType == "teacher") {
            localStorage.setItem("teacherId", res.data.data.teacher.id);
            that.names = res.data.data.teacher.name;
            that.schoolname = res.data.data.teacher.schoolName;
            localStorage.setItem("schoolId", res.data.data.teacher.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
            that.shouw = true;
          } else {
            that.shouw = true;
            that.slhuif = true;
            that.names = res.data.data.school.name;
            that.schoolname = res.data.data.school.name;
            localStorage.setItem("schoolId", res.data.data.schoolId);
            that.schoolgetinfo(res.data.data.schoolId);
          }
          localStorage.setItem("userName", that.names);
          localStorage.setItem("userId", res.data.data.userId);
        })

        .catch(() => {});
    },
    huifu(s) {
      let that = this;
      that.parentId = s.feelingId;
      that.replyRoleType = s.roleName;
      that.replyUserId = s.userId;
      that.replyUserName = s.userName;
      that.placeholder = "@" + s.userName;
    },
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime;
    },
    playerReadied(player, vul) {
      player.currentTime(vul);
    },
    onPlayerEnded(player) {
      this.playerOptions.controlBar.progressControl = true;
      this.watchOver = 1;
    },
    onPlayerPlay(player) {
      // console.log('player play!', player)
      //   player.pause();
      //   player.play();
    },
    onPlayerPause(player) {
      // player.play();
      // player.pause();
    },
    note() {
      let that = this;
      // that.loading = true

      let params = {
        courseId: that.courseId,
        lessonId: that.lessonId,
        noteTime: that.gklog,
        roleType: that.roleType,
        userId: that.userId,
        watchOver: that.watchOver,
      };
      note(params)
        .then((res) => {
          // that.loading = false
        })
        .catch(() => {
          // that.loading = false
        });
    },
    notecheckIsExist() {
      let that = this;
      that.loading = true;
      let params = {
        lessonId: that.lessonId,
      };
      notecheckIsExist(params)
        .then((res) => {
          that.loading = false;
          that.noteTime = res.data.data.noteTime;
          if (res.data.data.watchOver == 1) {
            that.playerOptions.controlBar.progressControl = true;
            that.watchOver = 1;
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },

    hasUsableFlash() {
      var flashObj;
      if (typeof window.ActiveXObject != "undefined") {
        flashObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      } else {
        flashObj = navigator.plugins["Shockwave Flash"];
      }
      return flashObj ? true : false;
    },
    // PC端用户进入观看直播
    PCIntoInsert() {
      if (this.isHaveRight == 0) {
        return false;
      }
      let date = localStorage.getItem("dates");
      if (!date) {
        date = new Date().getTime();
        localStorage.setItem("dates", date);
      }
      let ip = returnCitySN.cip + "@" + date;
      let params = {
        ip: ip,
        lessonId: this.lessonId,
      };
      PCIntoInsert(params).then((res) => {});
    },
    // PC端用户退出观看直播
    PcQuitUpate() {
      let params = {
        ip: returnCitySN.cip,
        lessonId: this.lessonId,
      };
      PcQuitUpate(params).then((res) => {
        return res;
      });
    },

    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    async unloadHandler() {
      let that = this;
      let time = this.formatDate();
      this._gap_time = new Date().getTime() - this.beforeUnload_time;
      //判断是窗口关闭还是刷新
      if (this._gap_time <= 5) {
        that.PcQuitUpate();
      }
    },
    // // 观看人数
    peoTimes() {
      this.peoTime = setInterval(() => {
        this.peoPageNum = 1;
        this.viewerWatchRecord();
      }, 60000);
    },
    // 观众列表 触底刷新
    loadPeo() {
      if (this.peoPageNum * 10 > this.peototalCount) {
        return false;
      }
      this.peoPageNum += 1;
      this.viewerWatchRecord();
    },
    // 获取当前观看人列表
    viewerWatchRecord() {
      let params = {
        lessonId: this.lessonId,
        pageNum: this.peoPageNum,
        pageSize: this.peoPageSize,
      };

      viewerWatchRecord(params).then((res) => {
        let data = res.data.data.dataList;
        if (this.peoPageNum == 1) {
          this.peopleList = [];
        }
        this.peopleList.push(...data);
        this.peototalCount = res.data.data.totalCount;
      });
    },
    // 课程点赞
    lessonZan() {
      // 节流
      let date = new Date().getTime();
      if (date - this.lessonZanDate < 500) {
        this.$message.error("知道您很喜欢，但是请慢慢点！");
      }
      this.lessonZanDate = date;
      clearTimeout(this.dianInter);
      this.dianInter = setTimeout(() => {
        let date = localStorage.getItem("dates");
        let ip = returnCitySN.cip + "@" + date;
        lessonZan({
          sourceId: ip,
          lessonId: this.lessonId,
        }).then((res) => {
          if (res.data.code == 0) {
            this.lessonZannum++;
            this.$message({
              message: "点赞成功",
              duration: 500,
              type: "success",
            });
            // this.courselesson(1);
          }
        });
      }, 500);
    },

    // 时间处理
    timeDeal(str) {
      let idx = str.indexOf(" ");
      let dealStr = str.slice(idx, 16);
      return dealStr;
    },
    // 判断token是否生效
    userInfo() {
      usercenterinfo().then((res) => {
        if (!res) {
          localStorage.clear();
          this.token = localStorage.getItem("token");
        }
        this.courselesson();
      });
    },
    // 开启直播中直播流刷新
    timeInter() {
      this.liveInter = setInterval(() => {
        this.getLiveStatus(2);
      }, 180000);
    },
    // 数量处理
    numberData(num) {
      let data = num;
      if (num >= 10000) {
        data = num.toString().slice(0, -3) / 10 + "万+";
      }
      return data;
    },
  },
  beforeRouteLeave(to, form, next) {
    // this.note();
    next();
  },
  destroyed() {},
  beforeDestroy() {
    localStorage.setItem("lessonId", this.lessonId);
    clearInterval(this.peoTime);
    clearTimeout(this.liveInter);
  },
  components: { videoPlayer },
  watch: {
    gklog() {
      if (!this.huix) {
        if (this.gklog > 0) {
          this.huix = true;
          this.playerReadied(this.$refs.videoPlayer.player, this.noteTime);
        }
      }
    },
  },
  computed: {
    // player() {
    // 	that.$refs.videoPlayer.player.play()
    // },
  },
  created() {
    this.lessonId = this.$route.query.id;
    this.lessonsid = this.$route.query.id;
    if (!this.token) {
      this.courselesson();
    } else {
      this.userInfo();
    }
    clearInterval(this.times);
    clearInterval(this.peoTime);
  },
  // },
  mounted() {
    // this.lessonfeelinglist(1);
    // this.lessonfeelinglist();
    let a = this.lessonId;
    window.onunload = function () {
      localStorage.setItem("lessonId", a);
      this.PcQuitUpate();
    };
    let that = this;
    window.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        that.$refs.videoPlayer.player.pause();
      } else {
        that.$refs.videoPlayer.player.play();
      }
    });
  },
};
</script>
<style >
#lives {
  min-height: 100vh;
  min-width: 1200px;
  padding: 40px 120px 120px 120px;
  box-sizing: border-box;
}
.vjs-error .vjs-error-display:before {
  display: none;
}
.vjs-modal-dialog .vjs-modal-dialog-content {
  line-height: 595px;
}
.title_right {
  color: rgba(255, 255, 255, 0.5);
  text-align: right;
  padding: 0px 10px;
}
.right_centent {
  width: 100%;
  min-width: 350px;
  min-height: 700px !important;
  background-color: #1a2133;
  border-radius: 5px;
  padding: 0px 10px;
  box-sizing: border-box;
}
.input_btn {
  display: flex;
  justify-content: space-around;
  /* align-items: center; */
}
.input_fa {
  position: relative;
  width: 85%;
  margin-bottom: 15px;
}
.btn_sub {
  position: absolute !important;
  right: 4px;
  top: 4px;
  background-image: linear-gradient(#ff9019, #ee502f);
}
/* .infinite-list {
} */
.user_com {
  margin-bottom: 15px;
  /* border-bottom: 1px solid #999; */
}
.infinite-list {
  height: 99%;
  width: 100%;
  /* padding: 5px; */
  overflow: auto;
  padding: 5px 15px;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-bottom: 15px;
}
.user_com_list {
  margin-bottom: 15px;
  display: flex;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #0e0f1e;
  border-radius: 5px;
}
.com_list_cen {
  margin-left: 10px;
  width: 100%;
}
/* 滚动条整体部分 */
.infinite-list::-webkit-scrollbar {
  display: none;
}
.del_centent {
  color: #58ccea;
  cursor: pointer;
  margin-right: 10px;
}
.select_centent {
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  margin-right: 15px;
}
.xian {
  display: inline-block;
  height: 1px;
  width: 36px;
  background-color: rgba(255, 255, 255, 0.5);
}
.xian_text {
  margin: 0px 10px;
  color: rgba(255, 255, 255, 0.5);
}
.peo_list {
  display: flex;
  align-items: center;
  background-color: #0e0f1e;
  padding: 10px 20px;
  margin-bottom: 15px;
  border-radius: 5px;
}
.live_title {
  font-size: 18px !important;
}
.dianzan {
  cursor: pointer;

  /* display: inline-block; */
}
.select_list {
  /* width: 100%; */
  padding: 0px 120px;
  color: #333;
}
.com_dianzhan {
  display: flex;
  align-items: center;
}
.com_dianzhan img {
  margin-right: 5px;
  cursor: pointer;
}
.com_list_u {
  display: flex;
  justify-content: space-between;
}
.playback_list {
  width: 100%;
  height: 100%;
  text-align: center;
  margin-top: 5px;
}
.playback {
  display: inline-block;
  background-color: #0e0f1e;
  width: 240px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.playback_c {
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.peo_num {
  display: inline-block;
  width: 100%;
  height: 20px;
  text-align: center;
  line-height: 20px;

  margin: 10px 0px 20px 0px;
}
.peo_num span {
  font-size: 16px !important;
}
.video_live {
  width: 98%;
  max-width: 1240px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.quename {
  width: 100%;
  height: 100vh;
  position: relative;
}
.que_img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* .dis_none {
  display: none;
} */
.cen_istop {
  display: inline-block;
  padding: 0px 4px;
  border-radius: 4px;
  font-size: 12px !important;
  background-color: #f5f5f5;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/index/live.vue